import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IChieuCaoCanNangActionTypes } from "../../action-types/dan-thuoc/IChieuCaoCanNangActionTypes";
import { IChieuCaoCanNangReducer } from "../../page-state-model/dan-thuoc/IChieuCaoCanNangReducer";
const iniState: IChieuCaoCanNangReducer = {
    status: ePageBaseStatus.is_not_initialization,
    filter: {
        dm_lop_id: 0,
        nam_hoc: "",
        thang: 0
    },
    hocSinhs: [],
    hocSinhSelectedId: 0,
    ketQuas: []
}
export const chieuCaoCanNangReducer = (
    state: IChieuCaoCanNangReducer = iniState,
    action: IChieuCaoCanNangActionTypes
): IChieuCaoCanNangReducer => {
    switch (action.type) {
        case "CHEU_CAO_CAN_NANG_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload,
            }
        case "CHEU_CAO_CAN_NANG_CHANGE_HOCSINH_SELECTED":
            return {
                ...state,
                hocSinhSelectedId: action.payload
            }
        case "CHEU_CAO_CAN_NANG_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "CHEU_CAO_CAN_NANG_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ketQuas: state.ketQuas.filter(x => x.id !== action.payload.id)
            }
        case "CHEU_CAO_CAN_NANG_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting,
            }
        case "CHEU_CAO_CAN_NANG_LOAD_HOC_SINH_SUCCESS":
            return {
                ...state,
                hocSinhs: action.payload,
            }
        case "CHEU_CAO_CAN_NANG_LOAD_KETQUA_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading,
            }
        case "CHEU_CAO_CAN_NANG_LOAD_KETQUA_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ketQuas: action.payload
            }
        case "CHEU_CAO_CAN_NANG_LOAD_KETQUA_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "CHEU_CAO_CAN_NANG_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving,
            }
        case "CHEU_CAO_CAN_NANG_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ketQuas: [...state.ketQuas.filter(x => x.id !== action.payload.id), action.payload]
            }
        case "CHEU_CAO_CAN_NANG_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "CHEU_CAO_CAN_NANG_SEND_NOTIFY_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving,
            }
        case "CHEU_CAO_CAN_NANG_SEND_NOTIFY_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ketQuas: [...state.ketQuas.filter(x => !action.payload.find(t=> t.id=== x.id)), ...action.payload]
            }
        case "CHEU_CAO_CAN_NANG_SEND_NOTIFY_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }

        default:
            return state;
    }
}